import { Badge, MenuItem } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";

import TextArea from "../../../../../../../../components/Form/TextArea";
import { colors } from "@zapalacorp/tokens";
import { Button } from "Components/Form";

export const LogicQuestionsSection = styled("section")(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));

export const GeneralContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "24px",
  borderRadius: "12px 12px 0 0",
  border: `1px solid ${colors.gray200}`,
}));

export const LogicQuestionsHeader = styled("div")(() => ({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const LogicQuestionsTitle = styled("span", {
  shouldForwardProp(propName) {
    return propName !== "hasError";
  },
})(({ hasError }: { hasError: boolean }) => ({
  fontSize: "22px",
  fontFamily: "Manrope",
  fontWeight: 700,
  lineHeight: "28px",
  color: hasError ? colors.error600 : colors.gray700,
  marginTop: "24px",
  marginBottom: "10px",
}));

export const PreviewButton = styled(Button)(() => ({
  padding: "10px 16px 10px 12px",
  fontSize: "12px",
}));

export const PreviewButtonText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));

export const AddQuestionButtonWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-start",
  width: "100%",
  padding: "24px 0",
}));

export const OptionWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
}));

export const OptionsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const WrapperRightSide = styled("div")(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "row",
}));

export const BadgeComponent = styled(Badge)(() => ({
  cursor: "pointer",
  margin: "0 10px",
  "& > span": {
    backgroundColor: "#E4E7EC",
    color: "#475467",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: 0.5,
    fontFamily: "Manrope",
  },
}));

export const TextAreaParagraph = styled(TextArea)(() => ({
  minHeight: "40px",
}));

export const OptionsButton = styled("div")(() => ({
  color: "#667085",
  backgroundColor: "#D0D5DD",
  borderRadius: 4,
  width: 16,
  height: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const EmptyOptionsWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 2,
}));

export const CurrentOptionsWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: 5,
}));

export const Option = styled(MenuItem)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "8px 12px !important",
}));

export const AddListSpan = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  color: colors.brandBlue500,
}));

export const RemoveListSpan = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  color: colors.error700,
}));

export const Placeholder = styled("span")(() => ({
  color: "#CDD1D8",
}));

export const OptionText = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const ButtonsContainer = styled("div")(() => ({
  display: "flex",
  padding: "16px 24px",
  justifyContent: "flex-end",
  alignItems: "center",
  border: `1px solid ${colors.gray200}`,
  marginTop: "-1px",
  marginBottom: "24px",
  borderRadius: "0 0 12px 12px",
}));

export const QuestionsErrorText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  lineHeight: "24px",
  color: colors.error600,
  alignItems: "center",
  display: "flex",
}));

const styles = makeStyles(() => ({
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
}));

export default styles;
